<div
  class="phase-list-container"
  *ngrxLet="{
    title: title$,
    subtitle: subtitle$,
    isTrialing: isTrialing$,
    daysLeftInTrial: daysLeftInTrial$,
    isAdminOrOwner: isAdminOrOwner$,
    phases: phases$,
    isFreeTier: isFreeTier$,
  } as vm">
  <div class="header-and-days-remaining">
    <div class="header">
      <div class="title">{{ vm.title }}</div>
      <ninety-button flat icon class="close-btn" (click)="close()" data-cy="phase-list-close-button">
        <terra-icon icon="x" size="20" />
      </ninety-button>
    </div>
    @if (vm.isTrialing) {
      <div class="days-remaining" [class.week-left]="vm.daysLeftInTrial <= 7">
        @if (vm.daysLeftInTrial <= 14) {
          <terra-icon icon="warning-triangle" variant="fill" size="16" />
        }
        <div [class.regular-text]="vm.daysLeftInTrial <= 14">{{ vm.daysLeftInTrial }} days remaining in your trial</div>
        @if (vm.isAdminOrOwner) {
          <a (click)="openPricingTierDialog()" class="subscribe-now">Subscribe now</a>
        }
      </div>
    }
  </div>

  <div class="phase-list">
    @if (vm.isFreeTier) {
      <div class="blurred-overlay"></div>
      <ninety-card class="subscribe-now-card">
        <div class="terra-body">Subscribe now to continue unlocking the power of Ninety.</div>
        @if (vm.isAdminOrOwner) {
          <button ninety-cm-button (click)="openPricingTierDialog()">
            <terra-icon icon="lightning" variant="fill"></terra-icon>
            Subscribe now
          </button>
        }
      </ninety-card>
    }

    <div class="subtitle">{{ vm.subtitle }}</div>

    @for (phase of vm.phases; track i; let i = $index) {
      <ninety-phase [phase]="phase" [previousPhaseTitle]="vm.phases[i - 1]?.title" (click)="selectPhase(phase)" />
    }
  </div>
</div>
